<template>
  <img :src="this.url"/>
</template>

<script>
import utils from './../js/utils'

export default {
  name: 'Avatar',
  props: {
    src: String
  },
  data () {
    return {}
  },
  computed: {
    url () {
      return utils.url(this.src) + '?v=1'
    }
  }
}
</script>

<style lang="scss" scoped>
  img {
    display: block;
    width: 40px;
    height: 40px;
    border: 1px solid #409EFF;
    border-radius: 50%;
  }
</style>
